import Banner from "./Banner";
import Schedule from "./Schedule";

export default function AboutSection({
  title,
  subtitle,
  background,
  description,
  image,
  subcontent,
}) {
  return (
    <div>
      <Banner title={title} background={background} subtitle={subtitle} />
      <Schedule subcontent={subcontent} description={description} image={image} />
    </div>
  );
}
